<template>
    <div class="d-flex d-md-none px-2">
        <button class="btn btn-outline-dark w-100 rounded-pill py-2 mobile-search-button" @click="mobileMenuToggle">
            <span>I am hungry</span>
            <div class="position-absolute btn btn-danger end-0 me-4 d-flex align-items-center justify-content-center search-icon">
                <i class="fas fa-search"></i>
            </div>
        </button>
    </div>




    <div class="d-none d-md-flex d-flex align-items-center bg-white backdrop-blur p-2 rounded-pill shadow search-bar-container">
        <!-- Use My Location -->
        <button @click="useMyLocation"
                class="btn btn-light btn-sm d-flex align-items-center justify-content-center location-btn"
                title="Use My Location">
            <i class="fas fa-crosshairs"></i>
        </button>

        <!-- Location Input -->
        <div class="flex-grow-1 px-3 border-start border-end position-relative">
            <label class="small fw-bold mb-0 text">Where</label>
            <input v-model="query"
                   @input="debouncedSearch"
                   placeholder="Enter town or address"
                   class="form-control border-0 bg-transparent p-0 fw-semibold" />

            <button v-if="query"
                    @click="clearQuery"
                    type="button"
                    class="btn btn-sm clear-btn">
                <i class="fas fa-times"></i>
            </button>
            <ul v-if="suggestions.length" class="list-group position-absolute z-3 w-100 shadow-sm mt-1">
                <li v-for="(s, i) in suggestions"
                    :key="i"
                    class="list-group-item list-group-item-action"
                    @click="selectSuggestion(s)">
                    {{ s.formatted }}
                </li>
            </ul>
        </div>

        <!-- Mode Dropdown -->
        <div class="mode-pill flex-grow-1 flex-basis-0 flex-md-basis-40 px-1 border-end">
            <div class="mode-pill-wrapper">
                <div class="mode-pill-toggle"
                     :class="{ 'move-right': mode === 'pickup' }"></div>
                <button class="mode-btn"
                        :class="{ active: mode === 'delivery' }"
                        @click="mode = 'delivery'">
                    Delivery
                </button>
                <button class="mode-btn"
                        :class="{ active: mode === 'pickup' }"
                        @click="mode = 'pickup'">
                    Pickup
                </button>
            </div>
        </div>


        <!-- Search Button -->
        <button @click="emitSearch"
                class="btn btn-danger d-flex align-items-center justify-content-center search-icon">
            <i class="fas fa-search"></i>
        </button>
    </div>
    <teleport to="body">
        <div v-if="mobileExpanded && !uiState.mainMenuOpen" class="mobile-search-overlay d-md-none extra-menu">
            <div class="p-3 position-relative">
                <button class="btn btn-dark mb-3" @click="mobileMenuToggle">
                    <i class="fas fa-chevron-left"></i> Back
                </button>

                <div class="d-flex flex-column gap-3">
                    <!-- Use My Location -->
                    <button @click="useMyLocation"
                            class="btn btn-primary d-flex align-items-center justify-content-center w-100"
                            title="Use My Location">
                        <i class="fas fa-crosshairs me-2"></i> Use My Location
                    </button>

                    <!-- Address Input -->
                    <div>
                        <ul v-if="suggestions.length" class="list-group position-relative mt-1 z-3">
                            <li v-for="(s, i) in suggestions"
                                :key="i"
                                class="list-group-item list-group-item-action"
                                @click="selectSuggestion(s)">
                                {{ s.formatted }}
                            </li>
                        </ul>
                        <input v-model="query"
                               @input="debouncedSearch"
                               placeholder="Enter town or address"
                               class="form-control" />

                        <button v-if="query"
                                @click="clearQuery"
                                type="button"
                                class="btn btn-sm clear-btn">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>

                    <!-- Mode Toggle -->
                    <div class="mode-pill-wrapper">
                        <div class="mode-pill-toggle" :class="{ 'move-right': mode === 'pickup' }"></div>
                        <button class="mode-btn" :class="{ active: mode === 'delivery' }" @click="mode = 'delivery'">
                            Delivery
                        </button>
                        <button class="mode-btn" :class="{ active: mode === 'pickup' }" @click="mode = 'pickup'">
                            Pickup
                        </button>
                    </div>

                    <!-- Search Button -->
                    <button @click="emitSearch" class="btn btn-danger w-100">
                        <i class="fas fa-search me-2"></i> Search
                    </button>
                </div>
            </div>
        </div>
    </teleport>
</template>



<style scoped>
    .list-group {
        background: #fff;
    }

    label.text {
        color: #333;
    }

    .search-bar-container {
        max-width: 100%;
        min-height: 56px;
        gap: 0.5rem;
        position: relative;
        box-shadow: 0px 0px 10px 1px #333 !important;
    }

    .location-btn {
        width: 55px;
        height: 55px;
        border-radius: 50%;
        flex-shrink: 0;
        background: #66017f;
        border-radius: 2rem 10% 10% 2rem;
    }

    .search-icon {
        width: 100px;
        height: 55px;
        border-radius: 10% 2rem 2rem 10%;
        flex-shrink: 0;
    }

    input::placeholder,
    select {
        color: #666;
    }

        input:focus,
        select:focus {
            box-shadow: none;
            outline: none;
        }

    .mode-pill-wrapper {
        background: #f0f0f0;
        border-radius: 999px;
        display: flex;
        position: relative;
        height: 55px;
        overflow: hidden;
    }

    .mode-pill-toggle {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 50%;
        background: #ff385c;
        border-radius: 999px;
        transition: left 0.25s ease;
        z-index: 1;
    }

        .mode-pill-toggle.move-right {
            left: 50%;
        }

    .mode-btn {
        flex: 1;
        z-index: 2;
        border: none;
        background: none;
        font-weight: 600;
        padding: 0;
        margin: 0;
        color: #444;
        transition: color 0.2s;
    }

        .mode-btn.active {
            color: white;
        }

    .mobile-search-overlay {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: white;
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
        box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
        z-index: 1150;
        animation: slideUp 0.3s ease-out;
        max-height: 90vh; /* avoids taking full height */
        overflow-y: auto;
    }


    @keyframes slideUp {
        from {
            transform: translateY(100%);
        }

        to {
            transform: translateY(0);
        }
    }

    .mobile-search-button {
        background: white;
        color: #333;
        height: 64px;
        transform-origin: right center;
    }

        .mobile-search-button:hover {
            transform: none !important;
        }

    .mobile-search-button .fa-search {
        color: white;
    }

    .search-bar-container, .mobile-search-button {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
        border-radius: 12px; /* optional: if not already applied */
    }
    .list-group-item{
        cursor:pointer;
    }

    .clear-btn {
        position: absolute;
        top: 50%;
        right: 23px;
        transform: translateY(-50%);
        background: #ccc;
        border: none;
        border-radius: 50%;
        width: 23px;
        height: 23px;
        font-size: 15px; 
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #333;
        cursor: pointer;
        padding: 0;
    }

        .clear-btn:hover {
            background: #999;
        }

</style>



<script setup>
    import { ref } from 'vue'

    import { inject, onMounted } from 'vue'

    const uiState = inject('uiState')
    import { useRoute, useRouter } from "vue-router";

     const router = useRouter();


    const mobileExpanded = ref(false)
    const emit = defineEmits(['locationSelected'])

    const query = ref('')
    const suggestions = ref([])
    const mode = ref('delivery')

    const GEOAPIFY_API_KEY = import.meta.env.VITE_GEOAPIFY_API_KEY
    const selectedSuggestion = ref(null)

    const selectSuggestion = (suggestion) => {
        selectedSuggestion.value = suggestion
        query.value = suggestion.formatted
        suggestions.value = []
        //emitSearch(suggestion)
    }

    let searchTimeout = null;
    const debouncedSearch = () => {
        if (searchTimeout) clearTimeout(searchTimeout);

        searchTimeout = setTimeout(() => {
            onSearchInput();
        }, 400);
    };

    const clearQuery = () => {
        query.value = '';
        selectedSuggestion.value = null;
        suggestions.value = [];
    };

    const onSearchInput = async () => {
        selectedSuggestion.value = null;
        if (query.value.length < 3) {
            suggestions.value = []
            return
        }

        const url = `https://api.geoapify.com/v1/geocode/autocomplete?text=${encodeURIComponent(query.value)}&limit=5&apiKey=${GEOAPIFY_API_KEY}`

        const response = await fetch(url)
        const data = await response.json()

        suggestions.value = data.features.map(feature => ({
            formatted: feature.properties.formatted,
            lat: feature.properties.lat,
            lon: feature.properties.lon,
            address_line1: feature.properties.address_line1,
            address_line2: feature.properties.address_line2,
            city: feature.properties.city,
            postcode: feature.properties.postcode
        }))
    }


    const mobileMenuToggle = () => {
        mobileExpanded.value = !mobileExpanded.value
        uiState.locationSearchOpen = mobileExpanded.value;
    }

    const useMyLocation = () => {
        if (!navigator.geolocation) return alert('Geolocation not supported.')

        navigator.geolocation.getCurrentPosition(async (pos) => {
            const { latitude, longitude } = pos.coords
            const url = `https://api.geoapify.com/v1/geocode/reverse?lat=${latitude}&lon=${longitude}&apiKey=${GEOAPIFY_API_KEY}`

            const response = await fetch(url)
            const data = await response.json()
            const result = data.features[0]

            if (result) {
                query.value = result.properties.formatted
                selectedSuggestion.value = {
                    formatted: result.properties.formatted,
                    lat: latitude,
                    lon: longitude,
                    address_line1: result.properties.address_line1,
                    address_line2: result.properties.address_line2,
                    city: result.properties.city,
                    postcode: result.properties.postcode

                }
            }
        }, (err) => {
            console.error(err)
            alert('Could not get your location.')
        })
    }
    import { useOrderStore } from 'shared-vue'

    const orderStore = useOrderStore();

    const emitSearch = (selected = null) => {
        const result = selectedSuggestion.value
        if (!result || !result.lat || !result.lon) {
            alert('Please select a valid location.');
            return;
        }
        orderStore.setAddress({
            address: '',
            city: '',
            postcode: ''
        });
        const modeValue = mode.value; // "delivery" or "pickup"
        window.localStorage.setItem('customerLocation', JSON.stringify({
            address: result.formatted,
            lat: result.lat,
            lng: result.lon,
            mode: modeValue,
            address_line1: result.address_line1,
            address_line2: result.address_line2,
            city: result.city,
            postcode: result.postcode
        }));

        if (window.location.pathname.includes('/vendors')) {
            router.replace({ path: '/refresh', query: { t: Date.now() } }).then(() => {
                router.replace('/vendors');
            });
        } else {
            router.push('/vendors');
        }
    };

    onMounted(() => {
        const saved = localStorage.getItem('customerLocation')
        if (saved) {
            try {
                const data = JSON.parse(saved)
                if (data.address && data.lat && data.lng) {
                    query.value = data.address
                    selectedSuggestion.value = {
                        formatted: data.address,
                        lat: data.lat,
                        lon: data.lng,
                        address_line1: data.address_line1,
                        address_line2: data.address_line2,
                        city: data.city,
                        postcode: data.postcode

                    }
                }

                if (data.mode === 'pickup' || data.mode === 'delivery') {
                    mode.value = data.mode
                }
            } catch (e) {
                console.error("Failed to load saved location:", e)
            }
        }
    })
</script>
